import { render, staticRenderFns } from "./SelectBrightness.vue?vue&type=template&id=633c1c4b"
import script from "./SelectBrightness.vue?vue&type=script&lang=js"
export * from "./SelectBrightness.vue?vue&type=script&lang=js"
import style0 from "./SelectBrightness.vue?vue&type=style&index=0&id=633c1c4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports